import React from 'react';

import { Box, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

import ReactHookFormSelect from 'common/components/form/ReactHookFormSelect'; // Ajusta la ruta según tu estructura

import { getPermissionLevelOptions } from '../helpers';

import StyledItem from './StyledItem';

const GroupItem = ({ control, disabled, index, item, name, roleLevel }) => {
    return (
        <StyledItem className={index % 2 === 0 ? 'StripedRow' : ''}>
            <Typography id={item.id} variant="caption">
                {item?.name}
            </Typography>
            <Box ml="auto">
                <ReactHookFormSelect
                    control={control} // Pasamos control de RHF
                    disabled={disabled}
                    name={name} // Nombre completo del campo (ej. "groups.0.permission_level")
                    options={getPermissionLevelOptions(roleLevel, item.id)}
                    sx={{ fontSize: '14px' }}
                    sxFormControl={{
                        '&.MuiFormControl-root': { mb: 0 },
                        '& .MuiInputBase-root': { mt: 0, fontSize: '14px' },
                    }}
                    variant="standard"
                />
            </Box>
        </StyledItem>
    );
};

GroupItem.propTypes = {
    control: PropTypes.object.isRequired, // Añadimos control como prop requerido
    disabled: PropTypes.bool,
    index: PropTypes.number,
    item: PropTypes.object,
    name: PropTypes.string,
    roleLevel: PropTypes.object,
};

export default GroupItem;
